<template>
  <div>
    <v-card flat class="mt-1">
      <v-form class="multi-col-validation">
        <div class="pa-3">
          <v-card-text>
            <v-card-title class="px-0 pt-0">
              <v-text-field
                class="pt-0"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar..."
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="users"
              :search="search"
              :header-props="{ sortByText: 'Ordenar por:' }"
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-btn
                    color="primary"
                    dark
                    class="mb-4"
                    style="margin-left: -17px"
                    @click="$emit('user-modal')"
                    v-if="hasPermission(2)"
                  >
                    Adicionar Usuário
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.active`]="{ item }">
                <v-chip label small outlined :color="item.active ? 'success' : 'danger'">
                  {{ item.active ? 'Ativo' : 'Inativo' }}
                </v-chip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <TooltipedBtn title="Editar" icon @click="editUser(item)" v-if="hasPermission(4)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </TooltipedBtn>
                <TooltipedBtn title="Remover" icon @click="deleteUser(item)" v-if="hasPermission(8) && item.id != user.id">
                  <v-icon>mdi-delete-outline</v-icon>
                </TooltipedBtn>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="search = ''">Resetar</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </div>
      </v-form>
    </v-card>
    <user-modal @success="getAll" />
    <user-delete @success="getAll" />
  </div>
</template>

<script>
import USER from '@/services/user'
import UserModal from '@/components/modals/UserModal.vue'
import UserDelete from '@/components/modals/UserDelete.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  components: { UserModal, UserDelete },
  data: () => ({
    loading: false,
    search: '',
    users: [],
    headers: [
      { text: 'Nome', value: 'name', sortable: true, align: 'start' },
      { text: 'E-mail', value: 'email', sortable: false },
      { text: 'Cargo', value: 'role', sortable: true },
      { text: 'Status', value: 'active', sortable: true, align: 'center' },
      { text: 'Ações', value: 'actions', sortable: false, align: 'end' },
    ],
  }),

  methods: {
    ...mapActions('auth', ['getPermissions']),
    async getAll() {
      try {
        this.loading = true
        const response = await USER.getAll()
        this.users = response.users
        this.loading = false
      } catch (e) {
        console.log(e)
        this.$toast.fire({
          icon: 'error',
          title: e.message || 'Erro ao buscar usuários',
        })
        this.$router.push({ name: 'dashboard' })
      }
    },
    editUser(user) {
      this.$emit('user-modal', user)
    },
    deleteUser(user) {
      this.$emit('user-delete', user)
    },
  },
  computed: {
    ...mapGetters('auth', ['hasPermission', 'user']),
  },

  mounted() {
    this.getAll()
    this.getPermissions()
  },
}
</script>

<style lang="scss" scoped>
.v-card__title {
  text-align: center !important;
  display: inherit;
}
</style>
